import { render, staticRenderFns } from "./PedidoAdm.vue?vue&type=template&id=70602cbf&scoped=true&"
import script from "./PedidoAdm.vue?vue&type=script&lang=js&"
export * from "./PedidoAdm.vue?vue&type=script&lang=js&"
import style0 from "./PedidoAdm.vue?vue&type=style&index=0&id=70602cbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70602cbf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
